<template>
    <div class="mobile-filters__buttons">
        <TotemButton @click="removeAllTags" :label="$t('General.clear')" />
        <TotemButton @click="hideMoreFilters" color="secondary" class="mobile-filters__button-done" :label="$t('General.done')" />
    </div>
</template>

<script>
    export default {
        name: 'ClearMobileFilters',
        methods: {
            removeAllTags () {
                this.$store.dispatch('Search/clearAllFilters')
            },
            hideMoreFilters () {
                this.$store.dispatch('CourseFilter/showMoreFilters', false)
            }
        },
        created () {
            this.hideMoreFilters()
        }
    }
</script>

<style scoped lang="scss">
.mobile-filters {
    &__buttons {
        display: flex;
        flex: 1;
        justify-content: center;
        margin: 20px 0 0;
    }

    &__button-done {
        margin: 0 0 0 10px;
    }
}
</style>
